import * as React from 'react';
import {Heading} from '../../utils/extractHeadings';

interface ITableOfContents {
  headings: Heading[];
}

export const TableOfContents = ({headings}: ITableOfContents) => {
  if (!headings || headings.length === 0) {
    return null;
  }

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
  };

  return (
    <div className="bg-bluerice rounded-[2rem] px-8 py-6 my-6">
      <h3 className="text-subtitlesmallmob lg:text-subtitlesmall font-semibold mb-4">
        In this article
      </h3>
      <ul className="list-disc list-outside pl-4 space-y-2">
        {headings.map((heading, index) => (
          <li key={index} className="text-smallbodymob lg:text-smallbody">
            <a
              href={`#${heading.id}`}
              onClick={e => handleClick(e, heading.id)}
              className="hover:font-semibold underline cursor-pointer">
              {heading.text}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
